









































































































import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class HomeBanner extends Vue {
  protected arrow = document.getElementById("arrow");
}
